<div class="admin-general-container">
    <div class="tabs">
        <tam-tab-set tid="admin_general_tabs" [selectedIndex]="selectedIndex" (selectChange)="onTabSelectChange($event)"
            class="tab-set">
            <tam-tab title="Entry"></tam-tab>
            <tam-tab title="Draft Note Entity"></tam-tab>
            <tam-tab title="Convert Address"></tam-tab>
            <tam-tab title="Configure HTML Security"></tam-tab>
            <tam-tab title="Abbreviation"></tam-tab>
            <tam-tab title="FMR Override"></tam-tab>
            <tam-tab title="Stop List"></tam-tab>
            <!-- <tam-tab title="Relationships"></tam-tab> -->
        </tam-tab-set>
        <div class="save" *ngIf="isShowCreateItemButton">
            <button tam-button tamType="primary" (click)="onCreateItemClick()">{{ buttonTitle}}</button>
        </div>
    </div>
    <div class="contents">
        <ng-container *ngIf="selectedIndex === 0">
            <div class="entry-draft">
                <div class="header">
                    <div class="title body-2">
                        {{'note.defaulting_note_type_of_a_sidenote' | stringLiterals}}
                    </div>
                    <div class="icon" kendoTooltip position="bottom" tooltipClass="tooltip-adjust-right"
                        [title]="tooltip">
                        <smart-icon name="info" class="notification">
                        </smart-icon>
                    </div>
                </div>
                <div class="content">
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [data]="typeItems"
                        [(ngModel)]="selectedItem">
                    </kendo-dropdownlist>
                </div>
                <div class="save">
                    <button tam-button tamType="primary" tamSize="normal" [tamLoading]="isProgressing"
                        [disabled]="isProgressing" (click)="onSaveEntryClick()">{{'general.save' |
                        stringLiterals}}</button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="selectedIndex === 1">
            <div class="entry-draft">
                <div class="header">
                    <div class="title body-2">
                        {{'note.select_an_default_entity_for_draft_note' | stringLiterals}}
                    </div>
                </div>
                <div class="content">
                    <kendo-dropdownlist #entityList [popupSettings]="{appendTo:'component',width:350}"
                        [(ngModel)]="entityItem" class="control-content" [data]="entityDatasource" [filterable]="true"
                        (open)="onOpenEntity($event)" (filterChange)="handleEntityFilter($event)"
                        [textField]="'shortName'" [valueField]="'id'" (selectionChange)="selectionChange($event)">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                        </ng-template>
                    </kendo-dropdownlist>
                </div>
                <div class="save">
                    <button tam-button tamType="primary" tamSize="normal" [tamLoading]="isProgressing"
                        [disabled]="isProgressing" (click)="onSaveDraftNotEntityClick()">{{'general.save' |
                        stringLiterals}}</button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="selectedIndex === 2">
            <div class="convert-address">
                Enable auto conversion
                <kendo-switch [(ngModel)]="isAutoConversion" onLabel="Yes" offLabel="No" class="conversion-item"
                    (valueChange)="updateAutoConversion($event)">
                </kendo-switch>
                <button tam-button tamType="primary" tamSize="normal" (click)="onConvertAllContactsAddress()"
                    class="dialog-button dialog-publish conversion-item">Convert all contacts address</button>

                <button tam-button tamType="primary" tamSize="normal" (click)="onConvertAllCorporatesAddress()"
                    class="dialog-button dialog-publish conversion-item">Convert all corporates address</button>

            </div>
        </ng-container>
        <div *ngFor="let item of config">
            <ng-container *ngIf="selectedIndex === item.index">
                <div class="grid">
                    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham"
                        [columnDefs]="item.columnDefs" [rowData]="item.rowData" [gridOptions]="gridOptions"
                        (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </ng-container>
        </div>
    </div>
</div>